import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StorageService } from 'src/app/core/services/storage.service';
import { CommonService } from 'src/app/core/services/common.service';
import { CommonHttpService } from './common-http.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EnforcementService {
private enforcementCount = new BehaviorSubject<number | null>(null);
enforcementCount$ = this.enforcementCount.asObservable();
  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private commonService: CommonService,
    private _commonHttpService: CommonHttpService
  ) {}

  fetchEnforcementList(data: any): Observable<any> {
    // Encrypt request
    const url = this.commonService.getFullUrl('fetchEnforcementList');
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }


    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
            this.enforcementCount.next(this.commonService.decryptUsingAES256(response.body.data).length);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  fetchAppealDocuments(data: any): Observable<any> {
        const url = this.commonService.getFullUrl("fetchDocumentList");
         const rqstBody = {
        responseguid:data,
        isDownload: true
      }
        let encryptedRqstBody = {
          rqstBody: this.commonService.encryptUsingAES256(rqstBody)
        }
       
        return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
          .pipe(map((response, error) => {
            if (response) {
              //console.log('file response: ', response);
              return response.body;
            } else {
              return error;
            }
          }));
      }   

  fetchEnforcementCount(){
    return this.enforcementCount;
  }

  fetchEnforcementDetail(data: any): Observable<any> {
    // Encrypt request
    const url = this.commonService.getFullUrl('fetchEnforcementDetail');
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }


    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('questionnaireList response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }
  fetchEnforcementHistoricalDetail(data: any): Observable<any> {
    // Encrypt request
    const url = this.commonService.getFullUrl('fetchEnforcementHistoricalDetail');
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }


    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('questionnaireList response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  fetchEnforcementHistory(data: any): Observable<any> {
    // Encrypt request
    const url = this.commonService.getFullUrl('fetchEnforcementHistory');
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }


    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('questionnaireList response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public saveEnforcement(data: any): Observable<any> {
    const url = this.commonService.getFullUrl('saveEnforcement');
    const encryptedRqstBody = { rqstBody: this.commonService.encryptUsingAES256(data) };
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response: any, error: any) => {
        if (response) {
          return response.body;
        } else {
          return error;
        }
      }));
  }

  /**
   * Upload file to server. Expects payload like:
   * { subjectId, filename, responseguid, documentBody (base64), notesType }
   * usage: this.enforcementService.uploadFileToServer(attachmentRqstBody)
   */
  public uploadFileToServer(data: any): Observable<any> {
    const url = this.commonService.getFullUrl('uploadEnforcementDocuments');
      const bodyToEncrypt = {
      "appealId": data.subjectId,
      "documents": [
        {
          "fileName": data.filename,
          "base64": data.documentBody
        }
      ]
    }
    const encryptedRqstBody = { rqstBody: this.commonService.encryptUsingAES256(bodyToEncrypt) };
    
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response: any, error: any) => {
        if (response) {
          return response.body;
        } else {
          return error;
        }
      }));
  }

  /**
   * Delete file from server. Expects payload like: { responseguid }
   * usage: this.enforcementService.deleteFileFromServer({ responseguid })
   */
  public deleteFileFromServer(data: any): Observable<any> {
    const url = this.commonService.getFullUrl('deleteEnforcement');
    const encryptedRqstBody = { rqstBody: this.commonService.encryptUsingAES256(data) };
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response: any, error: any) => {
        if (response) {
          return response.body;
        } else {
          return error;
        }
      }));
  }
}
